import { render, staticRenderFns } from "./ClinicalContentPage.vue?vue&type=template&id=5813675a"
import script from "./ClinicalContentPage.vue?vue&type=script&lang=js"
export * from "./ClinicalContentPage.vue?vue&type=script&lang=js"
import style0 from "./ClinicalContentPage.vue?vue&type=style&index=0&id=5813675a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports